<template>
    <div class="app-body">
        <div class="a-flex-rsbc">
            <bread-crumb></bread-crumb>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="false" id="leSearch">
                <le-select-remote-search 
                    v-model="pageParam.params.targetId" 
                    label="标的"
                    :options="optionsUnderlying" 
                    placeholder="请选择（可输入搜索）" />
                <le-company-investors-select label="资方" v-model="pageParam.params.companyId"></le-company-investors-select>
                <le-input-date type="month" label="账单月份" v-model="queryDate"></le-input-date>
                <le-select-local-search label="账单状态" v-model="pageParam.params.billStatus" :options="billStatusDic" />
            </le-search-form>
            <le-pagview ref="exportPage" @setData="setTableData" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.exportList">
                <el-table 
                    ref="exportList"
                    :data="tableData" 
                    :highlight-current-row="true" 
                    v-sticky="{ top: 0, parent:'.el-card__body' }"
                    style="width: 100%">
                    <el-table-column prop="" label="账单月份" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.countDate?row.countDate:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="标的" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.targetName?row.targetName:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="资方" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.companyName?row.companyName:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="期数" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.currentTerm }}/{{ row.totalTerm }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="兜底收益" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ util.numFormat(row.baseAmount || 0) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="经营收益" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ util.numFormat(row.incomeAmount || 0) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="实际收益" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ util.numFormat(row.realAmount || 0) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="应补收益" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ util.numFormat(row.reparationAmount || 0) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="账单状态" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.status | initDic(billStatusDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="操作" width="60" fixed="right">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="导出明细" placement="top">
                                <img src="../../assets/icon/option-export.png" class="a-wh-16" @click="handlerExport(scope.row)" />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
    </div>
</template>

<script>
import util from '@/utils/util'
export default {
    data() {
        return {
            util,
            tableData: [],
            queryDate: '',
            pageParam: {
                url: this.$Config.apiUrl.underlyingBill,
                method: "post",
                params: {
                    targetId: Number(this.$route.query.id),
                    startTime: '',
                    endTime: '',
                    billStatus: '',
                    companyId: ''
                },
                freshCtrl: 1,
            },
            optionsUnderlying: {
                url: this.$Config.apiUrl.underlyingPage,
                method: "post",
                params: {
                    companyId: ''
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
                pageSize: 1000
            },
            billStatusDic: [{label: '收益正常',value: 0},{label: '待补款',value: 1}]
        };
    },
    mounted () {

    },  
    activated () {
		this.pageParam.freshCtrl++;
	},
    methods: {
        setTableData(data,fileUrl) {
            this.tableData = data;
        },
        handlerRest() {
            this.pageParam.params = {
                targetId: '',
                startTime: '',
                endTime: '',
                billStatus: '',
                companyId: ''
            };
            this.queryDate = ''
            this.handlerSearch()
        },
        handlerSearch() {
            this.$refs['exportPage'].pageNum = 1
            if(this.queryDate) {
                this.pageParam.params.startTime = this.$getDay.getSomeMonthDays(this.queryDate).starttime + ' 00:00:00'
                this.pageParam.params.endTime = this.$getDay.getSomeMonthDays(this.queryDate).endtime + ' 23:59:59'
            }else {
                this.pageParam.params.startTime = ''
                this.pageParam.params.endTime = ''
            }
            this.pageParam.freshCtrl++;
        },
        handlerExport (data) {
            let startTime, endTime
            startTime = this.$getDay.getSomeMonthDays(data.countDate).starttime + ' 00:00:00'
            endTime = this.$getDay.getSomeMonthDays(data.countDate).endtime + ' 23:59:59'
            this.$exfile({
                code: 34,
                fileName: `${data.targetName}${data.countDate}收益明细表`,
                startTime: startTime,
                endTime: endTime,
                params: {
                    targetId: data.targetId,
                    startDate: startTime,
                    endDate: endTime,
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
